export const SuggestLineReport = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_5617_22867)">
      <path
        d="M12.8654 3.99482C12.4803 3.32954 11.5197 3.32954 11.1346 3.99483L1.86902 19.999C1.48306 20.6656 1.96411 21.5 2.73445 21.5H21.2656C22.0359 21.5 22.5169 20.6656 22.131 19.999L12.8654 3.99482Z"
        fillRule="evenodd"
        fill="#FC8800"
        stroke="#FC8800"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M12 17.5V18" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M12 9.50049L12.0042 14.5002" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_5617_22867">
        <rect height="24" width="24" fill="currentColor" transform="translate(0.8125)" />
      </clipPath>
    </defs>
  </svg>
);
